/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    }
];

export const createDefaultNavigation = (userData: any): FuseNavigationItem[] => [
{
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/users',
        hidden: () => {
            return !userData || !userData.permissions.includes('LIST_USERS');
        }
    },
    {
        id   : 'organizations',
        title: 'Organizations',
        type : 'basic',
        icon : 'heroicons_outline:squares-2x2',
        link : '/organizations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ORGANIZATION');
        }
    },    
    {
        id   : 'operations',
        title: 'Operations',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/operations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_OPERATION');
        }
    },
    {
        id   : 'channels',
        title: 'Channels',
        type : 'basic',
        icon : 'mat_outline:dns',
        link : '/channels',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CHANNEL');
        }
    },
    {
        id   : 'synthetic-profile',
        title: 'Synthetic profile',
        type : 'basic',
        icon : 'mat_outline:domain',
        link : '/synthetic-profile',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_SYNTHETIC_PROFILE');
        }
    },    
    {
        id   : 'profile',
        title: 'Profile',
        type : 'basic',
        icon : 'mat_outline:account_circle',
        link : '/profile'
    },
    {
        id   : 'clusters',
        title: 'Clusters',
        type : 'basic',
        icon : 'mat_outline:dashboard',
        link : '/clusters',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    },    
    {
        id   : 'sensia',
        title: 'Sensia',
        type : 'collapsable',
        icon : 'mat_outline:apps',
        children: [
            {
                id   : 'sensia-scheme',
                title: 'Scheme',
                type : 'basic',
                icon : 'mat_outline:apps',
                link : '/sensia',
                hidden: () => {
                    return !userData || !userData.permissions.includes('MANAGE_SCHEMAS');
                }
            },
            {
                id   : 'sensia-audit',
                title: 'Sensia audits',
                type : 'basic',
                icon : 'heroicons_outline:shield-check',
                link : '/sensia-audit',
                hidden: () => {
                    return !userData || !userData.permissions.includes('DO_AUDITS');
                }
            },
            {
                id   : 'queue',
                title: 'Queue',
                type : 'basic',
                icon : 'mat_outline:query_builder',
                link : '/queue',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_QUEUE');
                }
            },            
        ],         
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    },
    {
        id   : 'advanced_search',
        title: 'Advanced search',
        type : 'basic',
        icon : 'mat_outline:manage_search',
        link : '/search',
        hidden: () => {
            return !userData || !userData.permissions.includes('FIND_MESSAGES');
        }
    },    
    {
        id   : 'alerts',
        title: 'Alerts',
        type : 'basic',
        icon : 'mat_outline:notifications',
        link : '/alerts',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ALERT_CONFIGURATION');
        }
    },
    {
        id   : 'workflows',
        title: 'Workflows',
        type : 'basic',
        icon : 'mat_outline:auto_awesome_mosaic',
        link : '/workflows',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_WORKFLOW');
        }
    },
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/reports',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_REPORT');
        }
    },
    {
        id   : 'ewan',
        title: 'Ewan',
        type : 'collapsable',
        icon : 'mat_outline:dashboard',
        children: [
            {
                id   : 'ewan-dashboard',
                title: 'Dashboard',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/ewan/dashboard',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_EVENT');
                }                
            },              
            {
                id   : 'assets',
                title: 'Assets',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/assets',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_ASSET');
                }                
            },
            {
                id   : 'threats',
                title: 'Threats',
                type : 'basic',
                icon : 'mat_outline:pageview',
                link : '/ewan/threats',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_THREAT');
                }                     
            },
            {
                id   : 'events',
                title: 'Events',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/events',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_EVENT');
                }                
            },    
            {
                id   : 'ewan-config',
                title: 'Configuration',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/ewan/config',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_EWAN_CONFIG');
                }                
            },  
            {
                id   : 'alerts-registry',
                title: 'Alerts registry',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/ewan/alerts-registry',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_EVENT');
                }                
            },                                  
        ],         
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    }  
];
export const createCompactNavigation = (userData: any): FuseNavigationItem[] => [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/users',
        hidden: () => {
            return !userData || !userData.permissions.includes('LIST_USERS');
        }
    },
    {
        id   : 'organizations',
        title: 'Organizations',
        type : 'basic',
        icon : 'heroicons_outline:squares-2x2',
        link : '/organizations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ORGANIZATION');
        }
    },    
    {
        id   : 'operations',
        title: 'Operations',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/operations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_OPERATION');
        }
    },
    {
        id   : 'channels',
        title: 'Channels',
        type : 'basic',
        icon : 'mat_outline:dns',
        link : '/channels',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CHANNEL');
        }
    },
    {
        id   : 'profile',
        title: 'Profile',
        type : 'basic',
        icon : 'mat_outline:account_circle',
        link : '/profile'
    },
    {
        id   : 'synthetic-profile',
        title: 'Synthetic profile',
        type : 'basic',
        icon : 'mat_outline:domain',
        link : '/synthetic-profile',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_SYNTHETIC_PROFILE');
        }
    },
    {
        id   : 'queue',
        title: 'Queue',
        type : 'basic',
        icon : 'mat_outline:query_builder',
        link : '/queue',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_QUEUE');
        }
    },
    {
        id   : 'sensia',
        title: 'Sensia',
        type : 'basic',
        icon : 'mat_outline:apps',
        link : '/sensia',
        hidden: () => {
            return !userData || !userData.permissions.includes('MANAGE_SCHEMAS');
        }
    },
    {
        id   : 'sensia-audit',
        title: 'Sensia audits',
        type : 'basic',
        icon : 'heroicons_outline:shield-check',
        link : '/sensia-audit',
        hidden: () => {
            return !userData || !userData.permissions.includes('DO_AUDITS');
        }
    },
    {
        id   : 'alerts',
        title: 'Alerts',
        type : 'basic',
        icon : 'mat_outline:notifications',
        link : '/alerts',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ALERT_CONFIGURATION');
        }
    },
    {
        id   : 'advanced_search',
        title: 'Advanced search',
        type : 'basic',
        icon : 'mat_outline:manage_search',
        link : '/search',
        hidden: () => {
            return !userData || !userData.permissions.includes('FIND_MESSAGES');
        }
    },
    {
        id   : 'clusters',
        title: 'Clusters',
        type : 'basic',
        icon : 'mat_outline:dashboard',
        link : '/clusters',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    },
    {
        id   : 'workflows',
        title: 'Workflows',
        type : 'basic',
        icon : 'mat_outline:auto_awesome_mosaic',
        link : '/workflows',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_WORKFLOW');
        }
    },
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/reports',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_REPORT');
        }
    },
    {
        id   : 'ewan',
        title: 'Ewan',
        type : 'aside',
        icon : 'mat_outline:dashboard',
        children: [
            {
                id   : 'requirements',
                title: 'Requirements',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/nosecuantos',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_CLUSTER');
                }                
            },
            {
                id   : 'searchlinks',
                title: 'Search links',
                type : 'basic',
                icon : 'mat_outline:pageview',
                link : '/nosequintos',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_CLUSTER');
                }                     
            }
        ],         
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    },      
];
export const createFuturisticNavigation = (userData: any): FuseNavigationItem[] => [
{
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/users',
        hidden: () => {
            return !userData || !userData.permissions.includes('LIST_USERS');
        }
    },
    {
        id   : 'organizations',
        title: 'Organizations',
        type : 'basic',
        icon : 'heroicons_outline:squares-2x2',
        link : '/organizations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ORGANIZATION');
        }
    },    
    {
        id   : 'operations',
        title: 'Operations',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/operations',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_OPERATION');
        }
    },
    {
        id   : 'channels',
        title: 'Channels',
        type : 'basic',
        icon : 'mat_outline:dns',
        link : '/channels',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CHANNEL');
        }
    },
    {
        id   : 'profile',
        title: 'Profile',
        type : 'basic',
        icon : 'mat_outline:account_circle',
        link : '/profile'
    },
    {
        id   : 'synthetic-profile',
        title: 'Synthetic profile',
        type : 'basic',
        icon : 'mat_outline:domain',
        link : '/synthetic-profile',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_SYNTHETIC_PROFILE');
        }
    },
    {
        id   : 'queue',
        title: 'Queue',
        type : 'basic',
        icon : 'mat_outline:query_builder',
        link : '/queue',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_QUEUE');
        }
    },
    {
        id   : 'sensia',
        title: 'Sensia',
        type : 'basic',
        icon : 'mat_outline:apps',
        link : '/sensia',
        hidden: () => {
            return !userData || !userData.permissions.includes('MANAGE_SCHEMAS');
        }
    },
    {
        id   : 'sensia-audit',
        title: 'Sensia audits',
        type : 'basic',
        icon : 'heroicons_outline:shield-check',
        link : '/sensia-audit',
        hidden: () => {
            return !userData || !userData.permissions.includes('DO_AUDITS');
        }
    },
    {
        id   : 'alerts',
        title: 'Alerts',
        type : 'basic',
        icon : 'mat_outline:notifications',
        link : '/alerts',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_ALERT_CONFIGURATION');
        }
    },
    {
        id   : 'advanced_search',
        title: 'Advanced search',
        type : 'basic',
        icon : 'mat_outline:manage_search',
        link : '/search',
        hidden: () => {
            return !userData || !userData.permissions.includes('FIND_MESSAGES');
        }
    },
    {
        id   : 'clusters',
        title: 'Clusters',
        type : 'basic',
        icon : 'mat_outline:dashboard',
        link : '/clusters',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    },
    {
        id   : 'workflows',
        title: 'Workflows',
        type : 'basic',
        icon : 'mat_outline:auto_awesome_mosaic',
        link : '/workflows',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_WORKFLOW');
        }
    },
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/reports',
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_REPORT');
        }
    },
    {
        id   : 'ewan',
        title: 'Ewan',
        type : 'collapsable',
        icon : 'mat_outline:dashboard',
        children: [
            {
                id   : 'events',
                title: 'Events',
                type : 'basic',
                icon : 'mat_outline:admin_panel_settings',
                link : '/events',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_CLUSTER');
                }                
            },
            {
                id   : 'actives',
                title: 'Actives',
                type : 'basic',
                icon : 'mat_outline:pageview',
                link : '/activos',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_CLUSTER');
                }                     
            },         
            {
                id   : 'threats',
                title: 'Threats',
                type : 'basic',
                icon : 'mat_outline:pageview',
                link : '/nosequintos',
                hidden: () => {
                    return !userData || !userData.permissions.includes('READ_CLUSTER');
                }                     
            }
        ],         
        hidden: () => {
            return !userData || !userData.permissions.includes('READ_CLUSTER');
        }
    }    
];
export const createHorizontalNavigation = (userData: any): FuseNavigationItem[] => [
    {
        id   : 'dashboard',
        title: 'Example4',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    }
];
